module.exports = __webpack_public_path__ + "img/1F1F9-1F1EB.49402c41.svg";